import { io } from 'socket.io-client';
import { getState } from './callmanager';
import { ref } from 'vue'

const app_socket = ref(null);
const { callers, ringing_callers, activeExtCall } = getState();

const bridgeConnections = ref([]);

const activeCallCount = ref(0);

export async function initWebSocket() {
  console.log("Initializing WebSocket...");
  
  app_socket.value = io({transports: ["websocket"]})
  
  // 2. Listen for real-time queue updates
  app_socket.value.on('queue_update', (data) => {
  
    if (data.bridge_type === "holding_queue") {
      callers.value = data.callers;
      console.log("Received queue update", data);
      activeCallCount.value = callers.value.length + ringing_callers.value.length;
    } else if (data.bridge_type === "ringing_callers") {
      ringing_callers.value = data.callers;
      activeCallCount.value = callers.value.length + ringing_callers.value.length;
    } else if (data.bridge_type === "broadcast_bridge") {
      bridgeConnections.value = data.callers;
    }
  
  });
  
  app_socket.value.on('last_status', (data) => {
    console.log("Received last status", data);
    activeExtCall.value = data;
  });

  app_socket.value.on('hangup', (data) => {
    console.log("Received hangup event", data, activeExtCall.value);
    if (activeExtCall.value !== null) {
      console.log("Active Caller ID", activeExtCall.value.id || "No active call");
    }
    if (activeExtCall.value !== null && data.caller.id === activeExtCall.value.channel.id) {
      activeExtCall.value.hangup = true;
    }    
  });
}

export function getWebSocketState() {
  return { app_socket, bridgeConnections };
}

export function getStats() {
  return {activeCallCount};
}